/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Event} from "../../models/event";
import {Rule} from "../../models/rule";
import {EventService} from "../../services/event.service";
import {Component, Input, EventEmitter, Output, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from "../simple-success-error-dialog-box/simple-success-error-dialog-box.component";

declare var $: any;

const ID = "step1_selectTrigger";
const CAROUSEL_PAGE_LENGTH = 4;

@Component({
  selector: 'app-rule-editor-step-select-trigger',
  templateUrl: './rule-editor-step-select-trigger.component.html'
})
export class RuleEditorStepSelectTriggerComponent implements OnInit {
  
  /** Reference to the SimpleSuccessErrorDialog used to display error */
  @ViewChild('successErrorDialog') 
  simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

  //Main DIV ID, referenced here so it can be used in the .html as well as the JQuery stuff internal to this component
  mId = ID;

  @Input()    //Rule being edited
  mRule: Rule;

  //All known Events/Triggers available to the Rule
  mEvents: Event[];

  //Variables used by the Carousel logic
  mEventCarouselPages: EventCarouselPage[] = [];
  mEventsPageNumber = 1;
  mEventsSearchValue = "";


  constructor(
    private mRoute: ActivatedRoute,
    private mEventsService: EventService
  ) {}


  ngOnInit(): void {
    this.mRoute.data.subscribe((data: {events: Event[]}) => {
      console.log("Found Events: " + (data.events == null ? "*NULL*" : data.events));
      this.mEvents = data.events == null ? [] : data.events;
      this.refreshEventsCarouselPages();
    });
  }
  
  
  setVisible(visible: boolean): void {
    visible? $("#" + this.mId).show() : $("#" + this.mId).hide();
  }
  

  setEventsPageNumber(pageNumber: number): void {
    this.mEventsPageNumber = pageNumber;
  }

  refreshEventsCarouselPages(): void {
    const pages: EventCarouselPage[] = [];
    if (this.mEvents != null) {
      this.mEvents.forEach(event => {
        const add = this.mEventsSearchValue == null || this.mEventsSearchValue.length == 0 ? true : event.name.toLowerCase().includes(this.mEventsSearchValue.toLowerCase());

        if (add) {
          //Create a new Page if no Page currently exists or the last Page is already at the max number of size
          if (pages.length == 0 || pages[pages.length - 1].mEvents.length >= CAROUSEL_PAGE_LENGTH) {
            const newPage = new EventCarouselPage();
            newPage.mId = pages.length + 1;
            pages.push(newPage);
          }

          //Add the Event to the last Page
          pages[pages.length - 1].mEvents.push(event);
        }
      });
    }
    this.mEventCarouselPages = pages;
    this.mEventsPageNumber = 1;
  }

  getGlpyhForEvent(event: Event): string {
    return event.glyph == null || event.glyph.length == 0 ? "fa-users" : event.glyph;
  }

  selectEvent(event: Event): void {
    this._selectEvent(event);
  }

  private async _selectEvent(event: Event): Promise<void> {
    if (event == null || event.id == null) {
      this.mRule.conditions = []; //KHT 08/17/2021 - need to remove conditions before removing the trigger
      this.mRule.event = null;
    } else {
      try {
        this.mRule.event = await this.mEventsService.getEventById(event.id);
      } catch (error) {
        this.handleError(error);
      }
    }
  }


  /*
   * Generic Error Handling method
   * Displays error in an alert
   */
  private handleError(error: any): void {
    console.error("handleError() - Error: " + error);
    if (error != null) {
      const response: Response = error;
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, response.text().toString());
    }
  }

}

class EventCarouselPage {
  mId: number;
  mEvents: Event[] = [];
}
